import axios from 'axios';
import { GetState, SetState } from 'zustand';
import { BEHIND, COMPLETED, ON_PROGRESS } from '../../common/Types';
import {
  DailyTaskI,
  DailyTaskI as TaskI,
} from '../../interfaces/DailyTaskInterface';
import { AppStatesI } from '../interfaces/storeStatesInterface';
import {
  removeObjFromList,
  replaceObjFromList,
  setErrorMessage,
  todayTask,
} from './shareActionFuncs';

// development code
const host =
  window.location.host === 'localhost:3000' ? 'localhost' : '192.168.0.144';

export const getAllTasks = async (
  setState: SetState<AppStatesI>,
  get: GetState<AppStatesI>
) => {
  try {
    setState({ isLoading: true });
    const res = await axios.get(`http://${host}:5000/api/v1/tasks/all`);
    var tasks: TaskI[] = [];

    if (res.data) {
      tasks = res.data;

      setState({
        allTasks: tasks,
        isLoading: false,
      });
    } else {
      setErrorMessage(setState, res);
    }
  } catch (err) {
    console.log(err);
    setErrorMessage(setState, err);
  }
};

export const getDailyTasks = (
  setState: SetState<AppStatesI>,
  get: GetState<AppStatesI>,
  _date: Date
) =>
  setState((_prevState) => ({
    dailyTasks: _prevState.allTasks.filter(
      (_task) => _date.getDate() === new Date(_task.assignedDate).getDate()
    ),
  }));

export const getTodayTasks = (
  setState: SetState<AppStatesI>,
  _get: GetState<AppStatesI>
) =>
  setState((_prevState) => ({
    dailyTasks: _prevState.allTasks.filter((_task) => todayTask(_task)),
  }));

export const getGoalTasks = (
  setState: SetState<AppStatesI>,
  _get: GetState<AppStatesI>,
  goal_key: string
) =>
  setState((_prevState) => ({
    goalTasks: _prevState.allTasks
      .filter((_task) => _task.goal_key === goal_key)
      // development code
      .map((_task) =>
        todayTask(_task) ? { ..._task, taskStatus: ON_PROGRESS } : _task
      ),
  }));

// export const addDailyTasks = (setState: SetState<AppStatesI>, _get: GetState<AppStatesI>, _tasks: TaskI[]) =>
//     setState(_prevState => ({
//         allTasks: [..._prevState.allTasks, ..._tasks].sort((a, b) => Number(b.priority) - Number(a.priority))
//     }));

export const addTask = (
  setState: SetState<AppStatesI>,
  _get: GetState<AppStatesI>,
  nTask: TaskI
) =>
  setState((_prevState) => ({
    allTasks: [..._prevState.allTasks, nTask],
    // add new task to dailyTasks, if valid
    dailyTasks:
      todayTask(nTask) === true
        ? [..._prevState.dailyTasks, nTask]
        : _prevState.dailyTasks,
  }));

export const updateTask = async (
  setState: SetState<AppStatesI>,
  _get: GetState<AppStatesI>,
  nTask: TaskI
) =>
  setState((_prevState) => ({
    allTasks: replaceObjFromList(_prevState.allTasks, nTask, 'key'),
    dailyTasks: replaceObjFromList(_prevState.dailyTasks, nTask, 'key'),
    goalTasks: replaceObjFromList(_prevState.goalTasks, nTask, 'key'),
  }));

export const removeTask = (
  setState: SetState<AppStatesI>,
  _get: GetState<AppStatesI>,
  rTask: TaskI
) =>
  setState((_prevState) => ({
    allTasks: removeObjFromList(_prevState.allTasks, rTask, 'key'),
    dailyTasks: removeObjFromList(_prevState.dailyTasks, rTask, 'key'),
  }));

export const updateAllTaskStatus = (
  taskList: DailyTaskI[],
  updateTask: Function
) => {
  const _curDate = new Date();
  _curDate.setHours(0, 0, 0, 0);

  for (var i in taskList) {
    const _task = taskList[i];
    const _taskAsDate = new Date(_task.assignedDate);
    _taskAsDate.setHours(0, 0, 0, 0);
    if (
      _task.taskStatus !== COMPLETED &&
      _curDate.getFullYear() >= _taskAsDate.getFullYear() &&
      _curDate.getMonth() >= _taskAsDate.getMonth() &&
      _curDate.getDate() > _taskAsDate.getDate()
    ) {
      updateTask({ ..._task, taskStatus: BEHIND });
    } else if (
      _curDate.getFullYear() === _taskAsDate.getFullYear() &&
      _curDate.getMonth() === _taskAsDate.getMonth() &&
      _curDate.getDate() === _taskAsDate.getDate()
    ) {
      updateTask({ ..._task, taskStatus: ON_PROGRESS });
    }
  }
};
